import Vue from 'vue';
import VueRouter from "vue-router";

Vue.use(VueRouter);

import index from './pages/index'
import layout from './pages/layout'

import dashboard from './pages/dashboard'
import products from './pages/products'
import database from './pages/database'
import commission from './pages/commission'
import consultant from './pages/consultant'
import jsAdverts from './pages/jsAdverts'
import diyPromote from './pages/diyPromote'
const routes = [
    {
        path:'/',
        component:index
        
    },
    {
        path:'/index',
        component:index
    },
    {
        path:'/dashboard',
        component:layout,
        children:[
            {
                path:'/',
                component:dashboard
            },
            {
                path:'dashboard',
                component:dashboard
            },
            {
                path:'products',
                component:products
            },
            {
                path:'commission',
                component:commission
            },
            {
                path:'database',
                component:database
            },
            {
                path:'consultant',
                component:consultant
            },
            {
                path:'jsAdverts',
                component:jsAdverts
            },
            {
                path:'diyPromote',
                component:diyPromote
            },
        ]
    },
    
];
export default new VueRouter({routes});
